import { Label, Text, MessageBarType, Stack, StackItem } from '@fluentui/react';
import { useBoolean } from '@fluentui/react-hooks';
import * as React from 'react';
import { IUserContactInfo } from '../../../../../Models/Admin/IUserContactInfo';
import { IStatusMessage } from '../../../../../Models/IStatusMessage';
import { IAdminApi } from '../../../../../Services/API/Admin/IAdminApi';
import * as Services from '../../../../../Services/Services';

interface IAttendeeRegistrationContactsProps {
    userId?: string;

}


export const AttendeeRegistrationContacts: React.FunctionComponent<IAttendeeRegistrationContactsProps> = (props) => {
    const [isLoading, setIsLoading] = useBoolean(false);
    const [statusMessage, setStatusMessage] = React.useState<IStatusMessage>()
    const [contact, setContact] = React.useState <IUserContactInfo>()

 
    const loadData = async (userId: string)=>{

        setIsLoading.setTrue();
        setStatusMessage(undefined);
        const adminApi = Services.ServicesProvider.GetService<IAdminApi>(Services.AdminApi);
        const result = await adminApi.getUserContactInfo(userId);
        if (result.isSuccess && result.data) {
            setContact(result.data);
        }
        else {
            setStatusMessage({ message: result.message, type: MessageBarType.error });
        }
        setIsLoading.setFalse();
    }

    React.useEffect(() => {
        if (props.userId && props.userId != "") {
            loadData(props.userId);
        }
    }, [props.userId]);

    return (<Stack styles={{ root: { paddingTop:20 } }}>
        
        <Stack horizontal verticalAlign="center" tokens={{ childrenGap: 15 }}>
            <StackItem style={{ width:80 }}>
                <Label>Jmnéno</Label>
            </StackItem>
            <Text>{contact?.firstName + " " + contact?.lastName}</Text>
        </Stack>
        <Stack horizontal verticalAlign="center" tokens={{ childrenGap: 15 }}>
            <StackItem style={{ width: 80 }}>
                <Label>Telefon</Label>
            </StackItem>
            <Text>{contact?.phoneNumber}</Text>
        </Stack>
        <Stack horizontal verticalAlign="center" tokens={{ childrenGap: 15 }}>
            <StackItem style={{ width: 80 }}>
                <Label>Email</Label>
            </StackItem>
            <Text>{contact?.email}</Text>
        </Stack>
    </Stack>)
}
